import { Component } from '@angular/core'
import { DialogRef } from '@angular/cdk/dialog'

@Component({
    selector: 'app-save-selection-as-dialog',
    templateUrl: './save-selection-as-dialog.component.html',
    styleUrls: ['./save-selection-as-dialog.component.scss'],
})
export class SaveSelectionAsDialogComponent {
    constructor(private readonly dialogRef: DialogRef<string>) {}

    cancel(): void {
        this.dialogRef.close(undefined)
    }

    confirm(selectionName: string): void {
        this.dialogRef.close(selectionName)
    }
}
